import { render } from "./TenantMemberList.vue?vue&type=template&id=3bcb92cc"
import script from "./TenantMemberList.vue?vue&type=script&lang=js"
export * from "./TenantMemberList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__